import { apiGet, apiPut, apiPost } from '../helpers/ApiHelper';

import Auth from 'j-toker';
import moment from 'moment';

import * as notifications from './notificationActions';

function saveInspectionTemplates(templates) {
  return {
    type: 'LANDLORD_INSPECTIONS::SAVE_TEMPLATES',
    templates,
  };
}

export function getInspections() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/inspections/`)
        .done(response => {
          if (response.data) {
            response = response.data;
          }
          const parsedInspections = response.map(inspection => {
            inspection.date_created = moment(inspection.date_created).local();
            return inspection;
          });
          dispatch(saveInspections(parsedInspections));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

function saveInspections(inspections) {
  return {
    type: 'LANDLORD_INSPECTIONS::SAVE_INSPECTIONS',
    inspections,
  };
}

export function getInspectionTemplates() {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/inspections/templates`)
        .done(response => {
          dispatch(saveInspectionTemplates(response.templates));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function getFilteredInspectionTemplates(subset = 'active', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_INSPECTIONS::FETCH_FILTERED_TEMPLATES',
      payload: apiGet(
        `${Auth.getApiUrl()}/landlords/inspections/filtered_templates?subset=${subset}&offset=${offset}&${new URLSearchParams(
          options
        ).toString()}`
      ),
    }).catch(error => {
      dispatch(notifications.showFailure(error));
      console.error('request failed', error);
    });
  };
}

export function getInspectionTemplatesStats() {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_INSPECTIONS::FETCH_TEMPLATE_STATS',
      payload: apiGet(Auth.getApiUrl() + `/landlords/inspections/templates_stats`).catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      }),
    });
  };
}

export function createOrUpdateTemplate(formData) {
  if (formData.id) {
    return updateInspectionTemplate(formData);
  }

  return createInspectionTemplate(formData);
}

export function createInspectionTemplate(formData) {
  formData.properties = formData.properties && formData.properties.map(item => item.value);
  formData.unit_type_ids = formData.unit_type_ids && formData.unit_type_ids.map(item => item.value);
  return (dispatch, getState) => {
    return dispatch({
      type: 'LANDLORD_INSPECTIONS::CREATE_TEMPLATE',
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/inspections/templates`,
        formData
      ).catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
        return false;
      }),
    });
  };
}

export function updateInspectionTemplate(formData) {
  formData.properties = formData.properties && formData.properties.map(item => item.value);
  formData.unit_type_ids = formData.unit_type_ids && formData.unit_type_ids.map(item => item.value);
  return (dispatch, getState) => {
    return dispatch({
      payload: apiPut(
        // in the DesktopTable, we copy the id value to .original_id because we need to make randomized id values for VirtualizedTable
        // in the MobileTable, .original_id does not exist and .id is the correct id value
        Auth.getApiUrl() +
          `/landlords/inspections/templates/${formData.original_id || formData.id}`,
        formData
      )
        .done(response => {
          dispatch(notifications.showSuccess('updatedTemplate'));
          return true;
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          return false;
        }),
    });
  };
}
